import React from 'react';
import ReviewAvatar from './ReviewAvatar';
import ReviewHeader from './ReviewHeader';
import ReviewComment from './ReviewComment';
import ReviewImages from './ReviewImages';
import ReviewReplyBox from './ReviewReplyBox';
import ReviewVotes from './ReviewVotes';
import ReviewOwnerBtns from './ReviewOwnerBtns';
import ReviewOwnerFooter from './ReviewOwnerFooter';

const ReviewBox = (props) => {
    return (
        <div className="comment-main"> 
            <div className="reviews-comments-item">
                <ReviewAvatar user={props.review.user} />
                <div className="reviews-comments-item-text fl-wrap">
                    <ReviewHeader 
                        review={props.review}
                        isUser={props.isUser}
                    />                            
                    <ReviewComment 
                        comment={props.review.comment}
                    />
                    <br />
                    {props.review.images && props.review.images.length > 0 && (
                        <ReviewImages
                            images={props.review.images} 
                            firstName={props.review.user ? props.review.user.first_name : null}
                        />
                    )}
                    {props.isOwner && (
                        <>
                            {!props.isReply && (
                                <ReviewOwnerBtns
                                    review={props.review}
                                />
                            )}                   

                            <ReviewOwnerFooter 
                                review={props.review}
                            />
                        </>
                    )}
                    {props.isUser && (
                        <ReviewVotes
                            review={props.review}
                        /> 
                    )}
                </div>
            </div>
            {/* review reply */}
            {props.isUser && props.review.replies && props.review.replies.length > 0 && (
                <>
                    {props.review.replies.map((reply, i) => 
                        <ReviewReplyBox
                            key={i}
                            listing={props.review.listing}
                            reply={reply} 
                            logos={props.logos}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ReviewBox;